import { render, staticRenderFns } from "./PrefacePage.vue?vue&type=template&id=5596f654&scoped=true&"
import script from "./PrefacePage.vue?vue&type=script&lang=js&"
export * from "./PrefacePage.vue?vue&type=script&lang=js&"
import style0 from "./PrefacePage.vue?vue&type=style&index=0&id=5596f654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5596f654",
  null
  
)

export default component.exports